import React from 'react';
import { equals } from 'ramda';
import { useDropdown } from '@trevor/ui-components';
import ColumnName from '@/util/ColumnName';

export type ConfigurationOptionProps<T> = {
  option: T;
  selectedOption: T;
  onSelect: F0;
};
export const ConfigurationOption: React.FC<
  ConfigurationOptionProps<ColumnName>
> = ({ option, selectedOption, onSelect }) => {
  const { toggle } = useDropdown();

  const handleSelect = () => {
    onSelect();
    toggle();
  };

  return (
    <div
      key={`${option._name}.${option._alias}`}
      className={
        equals(option, selectedOption) ? 'selected-chart-configuration' : ''
      }
      onClick={handleSelect}
    >
      {option._name} {option._alias}
    </div>
  );
};
